import { getDefaultSections } from "./default_sections";

export const getDefaultPricingPageSections = ({ cookies, abTests, hasStudentPlan, hasFreeTier }) => {
  return getDefaultSections({ cookies, abTests, hasStudentPlan, hasFreeTier });
};
